import { createContext } from "react";

const ShareStudyContext = createContext();

export default ShareStudyContext;